var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m21.25 7.752-2.483-3.223a2 2 0 0 0-1.584-.779H6.817a2 2 0 0 0-1.584.78L2.75 7.751m18.5 0v1a2.96 2.96 0 0 1-1.028 2.237m1.028-3.237H2.75m0 0v1a2.96 2.96 0 0 0 1.028 2.237m11.305-2.237c0 1.658 1.38 3.001 3.084 3.001.79 0 1.51-.289 2.055-.764m-5.139-2.237v-1m0 1c0 1.658-1.38 3.001-3.083 3.001-1.703 0-3.083-1.343-3.083-3m0 0c0 1.657-1.38 3-3.084 3a3.12 3.12 0 0 1-2.055-.764m5.139-2.237v-1m5.139 12.498v-3.001c0-1.105-.92-2.001-2.056-2.001-1.135 0-2.056.896-2.056 2v3.002m-6.166-9.26v7.26a2 2 0 0 0 2 2h12.444a2 2 0 0 0 2-2v-7.26"
  })));
};
export default SvgStore;